import { uploadImageToS3 } from "api/news";
import PublishNotification from "components/Modal/PublishNotification";
import RejectNotification from "components/Modal/RejectNotification";
import ApproveNotification from "components/Modal/ApproveNotification";
import SubmitNotification from "components/Modal/SubmitNotification";
import dayjs from "dayjs";
import {
  clearDestination,
  setNotificationSettings,
} from "pages/Notification/notificationDestinationSlice"; // adjust path as needed
import { clearUploadedFiles } from "pages/Notification/notificationMediaSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dateUtils from "utils/dateUtils";
import utils from "utils/utils";
import { fetchWards } from "../../api/location";
import {
  addNotification,
  updateNotification,
  updateNotificationMedia,
} from "../../api/notification";
import { notificationStatusUpdate } from "../../api/notificationApprovalManagement";
import { retrieveUserData } from "../../utils/cryptoStorage";
import { canPublishWithoutApproval as canPublishByRole } from "../../utils/roles";
import Header from "./components/header";
import MessageContent from "./components/messageContent";
import NotificationSettings from "./components/notificationSettings";
import style from "./create_noti.module.scss";
import { validateForm } from "./helper/formValidation/formValidation";

function CreateNotification({
  setOpen,
  selectedNotificationDetails,
  notificationData,
  isDuplicate,
  isEdit,
  handleTabChange,
  approval,
  canPublishWithoutApproval: canPublishProp,
  setLoadTable,
  loadNotifications,
  setDetails,
  isReadOnly = false,
  isResubmission = false,
  viewStatus,
}) {
  const notificationSource = selectedNotificationDetails ?? notificationData;
  const uploadedFiles = useSelector(
    (state) => state.notificationMedia.uploadedFiles
  );
  const { destinationType, destinationScreen, externalLink, displayText } =
    useSelector((state) => state.notificationDestination);
  const [redirctionType, setRedirectionType] = useState(0);

  const dispatch = useDispatch();

  const mapFileType = (mimeType) => {
    if (mimeType.includes("image")) return 1;
    if (mimeType.includes("pdf")) return 2;
    if (mimeType.includes("video")) return 3;
    return null;
  };

  const userToken = retrieveUserData();
  let admin_user_id, admin_user_name;
  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }
  const canPublishWithoutApproval =
    canPublishProp !== undefined
      ? canPublishProp
      : canPublishByRole(userToken);

  const isRecipientsSelected = !utils.isEmpty(notificationSource?.wards);
  const scheduleFlg =
    isEdit && notificationSource?.scheduled_flg === 0 ? false : true;

  const alertTime = dateUtils.getDateTime(
    notificationSource?.alert_date_time,
    "time"
  );
  const startTime = dateUtils.getDateTime(
    notificationSource?.start_date_time,
    "time"
  );
  const endTime = dateUtils.getDateTime(
    notificationSource?.end_date_time,
    "time"
  );
  const startDate = dateUtils.getDateTime(
    notificationSource?.start_date_time,
    "date"
  );
  const endDate = dateUtils.getDateTime(
    notificationSource?.end_date_time,
    "date"
  );
  const expiryTime = dateUtils.getDateTime(
    notificationSource?.expiry_date_time,
    "time"
  );

  const [isLoading, setIsLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [formErrors, setFormErrors] = useState([]);
  const [expire, setExpire] = useState(
    isEdit && notificationSource?.expirydate
  );
  const [schedule, setSchedule] = useState(
    isEdit && scheduleFlg ? notificationSource?.alertdate : false
  );
  const [publish, setPublish] = useState(false);
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectFormData, setRejectFormData] = useState({
    remark: "",
    allow_resubmission_flg: false,
  });
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleFormData, setScheduleFormData] = useState({
    schedule_publish: true,
    schedule_date: null,
    schedule_time: null,
  });
  //recipientsFlag : 1 not selected , 2 selected, 0 selection cleared
  const [recipientsFlag, setRecipientsFlag] = useState(
    isRecipientsSelected ? 2 : 1
  );
  const [recipientsData, setRecipientsData] = useState(
    isEdit || isDuplicate
      ? isRecipientsSelected
        ? notificationSource?.wards.map((ward) => ({
            region_id: String(ward.region_id),
            region_name: String(ward.region_name),
            ward_code: String(ward.ward_code),
            ward_name: String(ward.ward_name),
          }))
        : [
            {
              label: "All citizens",
              value: "All citizens",
            },
          ]
      : []
  );

  // Form state
  const [formData, setFormData] = useState({
    notificationType:
      isEdit || isDuplicate ? notificationSource?.category : "General",
    recipients: recipientsData,
    title: isEdit || isDuplicate ? notificationSource?.title : "",
    messageContent:
      isEdit || isDuplicate ? notificationSource?.content : "",
    recipients_flg: recipientsFlag,
    expiryDate: isEdit ? notificationSource?.expirydate : undefined,
    expiryTime: isEdit ? expiryTime : null,
    scheduleDate:
      isEdit && scheduleFlg
        ? notificationSource?.alertdate
        : undefined,
    scheduleTime: isEdit && scheduleFlg ? alertTime : null,
    startDate: isEdit ? startDate : null,
    startTime: isEdit ? startTime : null,
    endDate: isEdit ? endDate : null,
    endTime: isEdit ? endTime : null,
  });

  const [notificationType, setNotificationType] = useState(
    formData?.notificationType
  );

  const [recipients, setRecipients] = useState([]);

  useEffect(() => {
    const loadWards = async () => {
      try {
        const wards = await fetchWards();
        const wardOptions = wards.map((ward) => ({
          label: `${ward.ward_code} - ${ward.region_name}`,
          value: `${ward.ward_code} - ${ward.region_name}`,
          wardCode: Number(ward.ward_code),
          wardName: ward?.ward_name,
          regionId: Number(ward.region_id),
          regionName: ward.region_name,
          wardStatusFlag: ward.ward_status_flg,
        }));
        if (!utils.isEmpty(wardOptions)) {
          setRecipients([
            {
              label: "All citizens",
              value: "All citizens",
            },
            ...wardOptions,
          ]);
        }
      } catch (error) {}
    };

    loadWards();
  }, [fetchWards]);

  const handleClose = () => {
    setOpen(false);
  };

  const isDestinationValid = () => {
    if (destinationType === "None") {
      return true;
    }
    if (destinationType === "In-app") {
      return destinationScreen && displayText;
    }
    if (destinationType === "External") {
      return externalLink && displayText;
    }
    return false;
  };

  const checkValidation = () => {
    const validationErrors = validateForm(formData, recipientsData, expire, schedule);
    const errorMessages = Object.values(validationErrors);

    if (destinationType !== "None" && !isDestinationValid()) {
      errorMessages.push("Please fill all required destination fields");
    }

    if (destinationType === "External" && externalLink) {
      try {
        new URL(externalLink);
      } catch {
        errorMessages.push("External URL must be a valid URL (e.g. https://example.com)");
      }
    }

    if (errorMessages.length > 0) {
      setFormErrors(errorMessages);
      return;
    }

    setFormErrors([]);
    if (approval) {
      setPublish(true);
    } else {
      setSubmitModalOpen(true);
    }
  };

  const getRedirectionType = (type) => {
    if (type === "In-app") return 1;
    if (type === "External") return 2;
    return 0;
  };

  function convertTo24Hour(timeStr) {
    if (!timeStr || (!timeStr.includes("AM") && !timeStr.includes("PM"))) {
      return timeStr;
    }
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = modifier === "AM" ? "00" : "12";
    } else if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  }

  const handleSave = async (type) => {
    if (type === "publish_now") {
      setIsLoading(true);
      try {
        const response = await notificationStatusUpdate({
          notification_content_id: notificationSource?.id,
          status: 4,
          modified_user_id: Number(admin_user_id),
          modified_user_name: admin_user_name,
          scheduled_flg: 0,
        });
        if (response?.statusCode === 200) {
          toast.success(response?.message || "Published successfully");
          handleClose();
          loadNotifications?.();
          if (setDetails) setDetails(false);
        } else {
          toast.error(response?.message || "Publish failed");
        }
      } catch (err) {
        toast.error(err?.message || "Publish failed");
      }
      setIsLoading(false);
      return;
    }

    if (type === "change_schedule") {
      setIsLoading(true);
      try {
        const scheduled_date =
          scheduleFormData.schedule_date && scheduleFormData.schedule_time
            ? dayjs(scheduleFormData.schedule_date, "DD-MM-YYYY").format("YYYY-MM-DD") +
              " " + scheduleFormData.schedule_time
            : null;
        const response = await notificationStatusUpdate({
          notification_content_id: notificationSource?.id,
          status: 5,
          modified_user_id: Number(admin_user_id),
          modified_user_name: admin_user_name,
          scheduled_flg: 1,
          scheduled_date,
        });
        if (response?.statusCode === 200) {
          toast.success(response?.message || "Schedule updated");
          setScheduleModalOpen(false);
          handleClose();
          loadNotifications?.();
          if (setDetails) setDetails(false);
        } else {
          toast.error(response?.message || "Schedule update failed");
        }
      } catch (err) {
        toast.error(err?.message || "Schedule update failed");
      }
      setIsLoading(false);
      return;
    }

    if (type === "approve" || type === "reject") {
      setIsLoading(true);
      try {
        const nid = notificationSource?.id;
        if (type === "approve") {
          const scheduled_date =
            schedule && formData?.scheduleDate && formData?.scheduleTime
              ? dayjs(formData.scheduleDate, "DD-MM-YYYY").format("YYYY-MM-DD") +
                " " +
                convertTo24Hour(formData.scheduleTime)
              : null;
          const response = await notificationStatusUpdate({
            notification_content_id: nid,
            status: schedule ? 5 : 4,
            modified_user_id: Number(admin_user_id),
            modified_user_name: admin_user_name,
            scheduled_flg: schedule ? 1 : 0,
            scheduled_date,
          });
          if (response?.statusCode === 200) {
            toast.success(response?.message || "Status updated");
            handleClose();
            loadNotifications?.();
            if (setDetails) setDetails(false);
          } else {
            toast.error(response?.message || "Update failed");
          }
        } else {
          const response = await notificationStatusUpdate({
            notification_content_id: nid,
            status: 3,
            modified_user_id: Number(admin_user_id),
            modified_user_name: admin_user_name,
            remarks: rejectFormData.remark || "",
            allow_resubmission_flg: rejectFormData.allow_resubmission_flg ? 1 : 0,
          });
          if (response?.statusCode === 200) {
            toast.success(response?.message || "Status updated");
            handleClose();
            loadNotifications?.();
            if (setDetails) setDetails(false);
          } else {
            toast.error(response?.message || "Update failed");
          }
        }
      } catch (err) {
        toast.error(err?.message || "Update failed");
      }
      setIsLoading(false);
      return;
    }
    if (destinationType !== "None" && !isDestinationValid()) {
      toast.warning("Please fill all required destination fields");
      return;
    }
    if (type === "draft") {
      setDraftLoading(true);
      handleTabChange && handleTabChange("3");
    } else if (type === "submit") {
      handleTabChange && handleTabChange("4");
    } else {
      handleTabChange && handleTabChange("1");
    }
    setIsLoading(true);
    const approverSchedule = approval && schedule;
    const creatorScheduleSubmission = !approval && schedule;
    const canSchedule = approverSchedule;
    const anySchedule = approverSchedule || creatorScheduleSubmission;
    const apiData = {
      notification_type: formData.notificationType === "General" ? 1 : 2,
      notification_title: formData.title,
      notification_content: formData.messageContent,
      content_status_flg:
        type === "draft" ? 0 : type === "submit" ? 1 : canSchedule ? 5 : 4,
      created_user_id: Number(admin_user_id),
      created_user_name: admin_user_name,
      scheduled_flg: anySchedule ? 1 : 0,
      recipients_flg: recipientsFlag,
      object_count: uploadedFiles?.length,
    };
    if (formData.notificationType !== "Alert" && destinationType !== "None") {
      apiData.redirection_type = getRedirectionType(destinationType);
      apiData.redirection_link =
        destinationType === "In-app" ? destinationScreen : externalLink;
      apiData.link_label = displayText;
    }

    if (recipientsFlag === 2) {
      apiData.wards = recipientsData;
    }
    if (
      formData.notificationType === "Alert" &&
      formData.startDate !== null &&
      formData.startDate !== ""
    ) {
      var date = dayjs(formData.startDate, "DD-MM-YYYY");

      var dateTime =
        date.format("YYYY-MM-DD") +
        (formData.startTime !== null
          ? ` ${formData.startTime.replace(/ AM| PM/g, "")}`
          : "");

      apiData.start_date = dateTime;
    }

    if (
      formData.notificationType === "Alert" &&
      formData.endDate !== null &&
      formData.endDate !== ""
    ) {
      var date = dayjs(formData.endDate, "DD-MM-YYYY");
      var dateTime = date.format("YYYY-MM-DD");
      if (formData.endTime !== null) {
        var cleanTime = formData.endTime.replace(/ AM| PM/g, "");
        dateTime += ` ${cleanTime}`;
      }
      apiData.end_date = dateTime;
    }

    if (anySchedule && formData?.scheduleDate && formData?.scheduleTime) {
      var date = dayjs(formData.scheduleDate, "DD-MM-YYYY");

      var dateTime =
        date.format("YYYY-MM-DD") +
        (formData.scheduleTime !== null
          ? ` ${formData.scheduleTime.replace(/ AM| PM/g, "")}`
          : "");
      apiData.scheduled_date = dateTime;
    }

    if (expire && formData?.expiryDate) {
      var date = dayjs(formData.expiryDate, "DD-MM-YYYY");
      var dateTime =
        date.format("YYYY-MM-DD") +
        (formData.expiryTime ? ` ${convertTo24Hour(formData.expiryTime)}` : " 23:59");
      apiData.expiry_date = dateTime;
    }

    const editApiData = {
      notification_content_id: notificationSource?.id,
      notification_type: formData.notificationType === "General" ? 1 : 2,
      notification_title: formData.title,
      notification_content: formData.messageContent,
      content_status_flg: type === "draft" ? 0 : type === "submit" ? 1 : canSchedule ? 5 : 4,
      recipients_flg: recipientsFlag,
      modified_user_id: Number(admin_user_id),
      modified_user_name: admin_user_name,
      scheduled_flg: anySchedule ? 1 : 0,
      redirection_type: redirctionType,
      object_count: uploadedFiles?.length,
    };
    if (formData.notificationType !== "Alert" && destinationType !== "None") {
      editApiData.redirection_type = getRedirectionType(destinationType);
      editApiData.redirection_link =
        destinationType === "In-app" ? destinationScreen : externalLink;
      editApiData.link_label = displayText;
    }
    if (recipientsFlag === 2) {
      editApiData.wards = recipientsData;
    }

    if (
      formData.notificationType === "Alert" &&
      formData.startDate !== null &&
      formData.startDate !== ""
    ) {
      var date = dayjs(formData.startDate, "DD-MM-YYYY");

      var dateTime = date.format("YYYY-MM-DD");

      var cleanTime = convertTo24Hour(formData.startTime);

      dateTime += ` ${cleanTime}`;

      editApiData.start_date = dateTime;
    }

    if (
      formData.notificationType === "Alert" &&
      formData.endDate !== null &&
      formData.endDate !== ""
    ) {
      var date = dayjs(formData.endDate, "DD-MM-YYYY");
      var dateTime = date.format("YYYY-MM-DD");
      if (formData.endTime !== null) {
        var cleanTime = convertTo24Hour(formData.endTime);
        dateTime += ` ${cleanTime}`;
      }
      editApiData.end_date = dateTime;
    }

    if (
      anySchedule &&
      formData?.scheduleDate &&
      formData?.scheduleTime &&
      formData.scheduleDate !== ""
    ) {
      var date = dayjs(formData.scheduleDate, "DD-MM-YYYY");

      // Check if scheduleTime is not null and then convert and format
      var dateTime = date.format("YYYY-MM-DD");
      if (formData.scheduleTime) {
        const time24 = convertTo24Hour(formData.scheduleTime);
        dateTime += ` ${time24}`;
      }

      editApiData.scheduled_date = dateTime;
    }
    if (expire && formData?.expiryDate && formData.expiryDate !== "") {
      var date = dayjs(formData.expiryDate, "DD-MM-YYYY");
      var dateTime =
        date.format("YYYY-MM-DD") +
        (formData.expiryTime ? ` ${convertTo24Hour(formData.expiryTime)}` : " 23:59");
      editApiData.expiry_date = dateTime;
    }
    const apiFunction = isEdit ? updateNotification : addNotification;

    try {
      const response = await apiFunction(isEdit ? editApiData : apiData);
      if (response?.statusCode === 200) {
        const successMessage =
          type === "submit"
            ? "Notification sent successfully"
            : response?.message;
        toast.success(successMessage);

        const notification_content_id = isEdit
          ? Number(notificationSource?.id)
          : Number(response?.data?.notificationId);

        if (uploadedFiles?.length > 0) {
          const uploadTargets = response?.data?.files;

          const uploadErrors = [];

          for (let i = 0; i < uploadedFiles?.length; i++) {
            const file = uploadedFiles[i];
            const target = uploadTargets[i]; // assumes same order

            try {
              await uploadImageToS3(file, target?.notification_upload_path);
            } catch (err) {
              console.error(`Upload failed for ${file?.name}:`, err);
              uploadErrors.push(file?.name);
            }
          }

          if (uploadErrors?.length === 0) {
            toast.success("All files uploaded successfully");
          } else if (uploadErrors.length === uploadedFiles.length) {
            toast.error(`Notification saved but all file uploads failed: ${uploadErrors.join(", ")}`);
          } else {
            toast.warning(`Notification saved. ${uploadErrors.length} file(s) failed to upload: ${uploadErrors.join(", ")}`);
          }

          const filesPayload = uploadedFiles.map((file, index) => ({
            notification_file_name: file.name,
            notification_file_size: file.size,
            notification_file_mimetype: file.type,
            notification_filepath: uploadTargets[index].notification_filepath,
            file_type: mapFileType(file.type),
          }));

          await updateNotificationMedia({
            notification_content_id,
            action: "insert",
            files: filesPayload,
          });

          dispatch(clearUploadedFiles());
        }
      } else {
        toast.error(response?.message);
      }
      setIsLoading(false);
      setDraftLoading(false);
      handleClose();
      if (loadNotifications) loadNotifications();
      if (setLoadTable) setLoadTable((prev) => !prev);
      if (setDetails) setDetails(false);
    } catch (error) {
      setIsLoading(false);
      setDraftLoading(false);
    }
  };

  // Form input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const disableScheduleDate = (current) => {
    const today = dayjs().startOf("day");
    const expiryDate = formData.expiryDate
      ? dayjs(formData.expiryDate, "DD-MM-YYYY").endOf("day")
      : null;

    return current && (current < today || (expiryDate && current > expiryDate));
  };

  const disableExpiryDate = (current) => {
    const today = dayjs().startOf("day");
    const scheduleDate = formData.scheduleDate
      ? dayjs(formData.scheduleDate, "DD-MM-YYYY").endOf("day")
      : null;

    return (
      current && (current < today || (scheduleDate && current <= scheduleDate))
    );
  };

  const disableStartDate = (current) => {
    const today = dayjs().startOf("day");
    return current && current < today;
  };

  const disableEndDate = (current) => {
    const startDate = formData.startDate
      ? dayjs(formData.startDate, "DD-MM-YYYY").startOf("day")
      : null;
    const today = dayjs().startOf("day");
    return current && (current < today || (startDate && current < startDate));
  };

  useEffect(() => {
    if (!expire) {
      setFormData((prevData) => ({
        ...prevData,
        expiryDate: null,
        expiryTime: null,
      }));
    }
    if (!schedule) {
      setFormData((prevData) => ({
        ...prevData,
        scheduleDate: null,
        scheduleTime: null,
      }));
    }
  }, [expire, schedule]);

  useEffect(() => {
    if (isEdit) {
      dispatch(setNotificationSettings(notificationSource?.category));
    }
  }, [notificationSource]);

  useEffect(() => {
    if (!isEdit && !isDuplicate && !notificationSource) {
      dispatch(clearDestination());
      dispatch(clearUploadedFiles());
    }
  }, [isEdit, isDuplicate, notificationSource, dispatch]);

  return (
    <>
      <div className="w-full create">
        {/* Header */}
        <Header
          handleClose={handleClose}
          isEdit={isEdit}
          draftLoading={draftLoading}
          checkValidation={checkValidation}
          formData={formData}
          recipientsData={recipientsData}
          schedule={schedule}
          expire={expire}
          handleSave={handleSave}
          approval={approval}
          isResubmission={isResubmission}
          isReadOnly={isReadOnly}
          isLoading={isLoading}
          onReject={() => setRejectOpen(true)}
          viewStatus={viewStatus}
          onChangeSchedule={() => setScheduleModalOpen(true)}
        />
        {isReadOnly && viewStatus === 3 && (() => {
          const activities = notificationSource?.activity || notificationSource?.activities;
          const reason = Array.isArray(activities)
            ? activities.find((a) => a?.news_status_remarks)?.news_status_remarks
            : notificationSource?.remarks || notificationSource?.rejection_reason;
          return reason ? (
            <div
              style={{
                background: "#FFF1F0",
                border: "1px solid #FFA39E",
                borderRadius: 8,
                padding: "12px 16px",
                margin: "0 24px 16px",
              }}
            >
              <p style={{ fontWeight: 600, color: "#CF1322", fontSize: 14, marginBottom: 4 }}>
                Reason for rejection
              </p>
              <p style={{ color: "#434343", fontSize: 14, margin: 0 }}>
                {reason}
              </p>
            </div>
          ) : null;
        })()}
        {formErrors.length > 0 && (
          <div
            style={{
              background: "#fff1f0",
              border: "1px solid #ffa39e",
              borderRadius: 8,
              padding: "12px 16px",
              margin: "0 24px 12px",
            }}
          >
            <p style={{ fontWeight: 600, color: "#cf1322", fontSize: 14, marginBottom: 6 }}>
              Please fix the following before submitting:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {formErrors.map((err, i) => (
                <li key={i} style={{ color: "#434343", fontSize: 13 }}>{err}</li>
              ))}
            </ul>
          </div>
        )}
        <div className={`flex ${style["content-wrapper"]}`}>
          {/* Left Section : Notification Settings */}
          <NotificationSettings
            notificationType={notificationType}
            setNotificationType={setNotificationType}
            setFormData={setFormData}
            formData={formData}
            disableStartDate={disableStartDate}
            disableEndDate={disableEndDate}
            isDuplicate={isDuplicate}
            isEdit={isEdit}
            recipients={recipients}
            recipientsData={recipientsData}
            setRecipientsFlag={setRecipientsFlag}
            setRecipientsData={setRecipientsData}
            expire={expire}
            setExpire={setExpire}
            disableExpiryDate={disableExpiryDate}
            schedule={schedule}
            disableScheduleDate={disableScheduleDate}
            setSchedule={setSchedule}
            isReadOnly={isReadOnly}
            showSchedule={true}
            scheduleLabel={approval ? "Schedule for publishing" : "Schedule submission for approval"}
          />
          {/* Right Section : message content */}
          <MessageContent
            data={notificationSource}
            formData={formData}
            handleInputChange={handleInputChange}
            notificationType={notificationType}
            setFormData={setFormData}
            isReadOnly={isReadOnly}
          />
        </div>
      </div>
      {/* Confirmation Modal */}
      <PublishNotification
        isLoading={isLoading}
        onSubmit={() => handleSave("publish")}
        open={publish}
        item={formData.title}
        setOpen={setPublish}
      />
      <SubmitNotification
        open={submitModalOpen}
        setOpen={setSubmitModalOpen}
        loading={isLoading}
        onSubmit={() => {
          handleSave("submit");
          setSubmitModalOpen(false);
        }}
      />
      <RejectNotification
        open={rejectOpen}
        setOpen={setRejectOpen}
        isLoading={isLoading}
        formData={rejectFormData}
        setFormData={setRejectFormData}
        onSubmit={() => {
          setRejectOpen(false);
          handleSave("reject");
        }}
      />
      <ApproveNotification
        title="Change Schedule"
        formData={scheduleFormData}
        setFormData={setScheduleFormData}
        isLoading={isLoading}
        open={scheduleModalOpen}
        setOpen={setScheduleModalOpen}
        onSubmit={() => handleSave("change_schedule")}
        onCancel={() => setScheduleModalOpen(false)}
        expiryDate={notificationSource?.expirydate}
      />
    </>
  );
}

export default CreateNotification;
